import React, { memo, useEffect, useState } from 'react';
import {
  withMeQuery,
  withSavePreference,
} from 'chameleon/packages/blue-book-player/hocs/user';
import { compose } from 'react-apollo';
import { BLUEBOOK_TOOLBAR_OPTIONS } from 'chameleon/packages/blue-book-player/constants/preferences';
import Option from './Option';
import { FORMATTING_OPTIONS, ToolbarSeparator } from './constants';

const Toolbar = memo(
  ({
    element,
    formattingOptions,
    savePreference,
    meQuery,
    isBluebookDigitalExam,
    userData,
    subjectId,
    isSecure,
  }) => {
    const [touched, setTouched] = useState(false);

    useEffect(() => {
      const editorElement = element.querySelector('.lrn_texteditor_editable');
      if (!editorElement) return;

      const observer = new MutationObserver(() => {
        if (editorElement.innerText.trim()) {
          setTouched(true);
        }
      });
      observer.observe(editorElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      return () => {
        observer.disconnect(editorElement);
      };
    }, [element]);

    const preferenceValue = JSON.parse(
      (userData?.me?.preferences || []).find(
        ({ preference }) => preference === BLUEBOOK_TOOLBAR_OPTIONS,
      )?.value || '{}',
    );

    return (
      <div className="rounded-t-md border border-bluebook-gray5 border-b-none bg-white w-full h-auto flex pl-[3px] flex-wrap">
        {formattingOptions.map((option, i) =>
          option === ToolbarSeparator ? (
            <div
              key={`separator-${i}`}
              className="w-1 h-auto border-l border-bluebook-gray-400 my-2 ml-1"
            />
          ) : (
            <Option
              key={option}
              editorTouched={touched}
              element={element}
              option={FORMATTING_OPTIONS[option] ?? option}
              isBluebookDigitalExam={isBluebookDigitalExam}
              savePreference={savePreference}
              preferenceValue={preferenceValue}
              meQuery={meQuery}
              subjectId={subjectId}
              isSecure={isSecure}
            />
          ),
        )}
      </div>
    );
  },
);

export default compose(withMeQuery, withSavePreference)(Toolbar);
